import { Heading, Paragraph } from "../../../atoms";
import { Box } from "../../../cores";
import { Table } from "../../../molecules";

interface IKidSafetyDescriptionTable {
  isMobile: boolean;
  descriptionTitle: string;
  descriptionText: string;
}
const KidSafetyDescriptionTable = ({
  isMobile,
  descriptionTitle,
  descriptionText,
}: IKidSafetyDescriptionTable) => {
  return (
    <Box
      sx={{
        width: "100%",
        "> p": {
          fontSize: ["xs", null, "16px", null, null],
          marginBottom: "10px !important",
        },
      }}
    >
      <Heading as={"h4"} variant={!isMobile ? "h5" : "h6"}>
        {descriptionTitle}
      </Heading>
      <Paragraph>{descriptionText}</Paragraph>
      <Table firstColumnSticky={false} zebra={true} isMobile={false}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderColumn
              sx={{
                backgroundColor: "senaryScale.3",
                textAlign: "center",
              }}
            >
              Betyg
            </Table.HeaderColumn>
            <Table.HeaderColumn
              sx={{
                backgroundColor: "#FFFFFF",
                textAlign: "center",
                border: "none",
              }}
            >
              1
            </Table.HeaderColumn>
            <Table.HeaderColumn
              sx={{
                backgroundColor: "#ECF9FE",
                textAlign: "center",
                "> div": {
                  border: "none",
                },
              }}
            >
              2
            </Table.HeaderColumn>
            <Table.HeaderColumn
              sx={{
                backgroundColor: "#ECF9FE",
                textAlign: "center",
              }}
            >
              2
            </Table.HeaderColumn>
            <Table.HeaderColumn
              sx={{
                backgroundColor: "#007AC4",
                textAlign: "center",
                color: "white",
              }}
            >
              3
            </Table.HeaderColumn>
            <Table.HeaderColumn
              sx={{
                backgroundColor: "#007AC4",
                textAlign: "center",
                color: "white",
              }}
            >
              3*
            </Table.HeaderColumn>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Column sx={{ left: 0, position: "relative" }}>
              Bältes­påminnare bak
            </Table.Column>
            <Table.Column>Tillval/Saknas</Table.Column>
            <Table.Column>Std</Table.Column>
            <Table.Column>Std </Table.Column>
            <Table.Column>Std </Table.Column>
            <Table.Column>Std </Table.Column>
          </Table.Row>
          <Table.Row>
            <Table.Column>Bältes­sträckare bak</Table.Column>
            <Table.Column>Tillval/Saknas</Table.Column>
            <Table.Column>Std</Table.Column>
            <Table.Column>&#8211;</Table.Column>
            <Table.Column>Std </Table.Column>
            <Table.Column>Std </Table.Column>
          </Table.Row>
          <Table.Row>
            <Table.Column>Bältes­kraft­begränsare bak</Table.Column>
            <Table.Column>Tillval/Saknas</Table.Column>
            <Table.Column>&#8211;</Table.Column>
            <Table.Column>Std</Table.Column>
            <Table.Column>Std</Table.Column>
            <Table.Column>Std </Table.Column>
          </Table.Row>
          <Table.Row>
            <Table.Column>Sidokrock­gardin bak</Table.Column>
            <Table.Column>Tillval/Saknas</Table.Column>
            <Table.Column>Std</Table.Column>
            <Table.Column>Std</Table.Column>
            <Table.Column>Std</Table.Column>
            <Table.Column>Std </Table.Column>
          </Table.Row>
          <Table.Row>
            <Table.Column>Integrerad­ fv barnstol</Table.Column>
            <Table.Column>&#8211;</Table.Column>
            <Table.Column>&#8211;</Table.Column>
            <Table.Column>&#8211;</Table.Column>
            <Table.Column>&#8211;</Table.Column>
            <Table.Column>Std </Table.Column>
          </Table.Row>
        </Table.Body>
      </Table>
    </Box>
  );
};

export default KidSafetyDescriptionTable;
